import request from "../request";

export default {
 

  //热点-添加
  add(data) {
    return request.post("/point/add", data);
  },

  //热点-修改
  edit(data) {
    return request.post("/point/edit", data);
  },

  //热点-删除
  delete(data) {
    return request.post("/point/delete", data);
  },
  
 
  
  
  
};
